














import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'

import CategoryMenu from '../../common/components/CategoryMenu.vue'

export default Vue.extend({
  name: 'CategoryMenuSection',
  components: {
    CategoryMenu
  },
  props: {
     productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    }
  }
})
